var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_754",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_754)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.1749 24.175C4.4249 24.175 3.7959 23.921 3.2879 23.413C2.77924 22.9043 2.5249 22.275 2.5249 21.525V7.87499C2.5249 7.12499 2.77924 6.49566 3.2879 5.98699C3.7959 5.47899 4.4249 5.22499 5.1749 5.22499H14.0749L11.4249 7.87499H5.1749V21.525H18.8249V15.275L21.4749 12.625V21.525C21.4749 22.275 21.2209 22.9043 20.7129 23.413C20.2042 23.921 19.5749 24.175 18.8249 24.175H5.1749ZM15.9249 6.19999L17.6499 7.87499L11.1499 14.325V15.55H12.3499L18.8499 9.07499L20.5249 10.725L13.3499 17.925H8.7749V13.35L15.9249 6.19999ZM20.5249 10.725L15.9249 6.19999L18.2249 3.89999C18.7582 3.36666 19.3916 3.10399 20.1249 3.11199C20.8582 3.12066 21.4832 3.39166 21.9999 3.92499L22.7999 4.74999C23.2999 5.26666 23.5499 5.88733 23.5499 6.61199C23.5499 7.33733 23.2916 7.95833 22.7749 8.47499L20.5249 10.725Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.6dacd3cd95f9f52a732e3cbb02ebfdf8.svg";
export { ForwardRef as ReactComponent };